export default __webpack_public_path__ + "img/mobile.0355c73c.svg";